module.exports = __webpack_public_path__ + "img/ee6bb05.jpg";